<div class="video-area">
    <div class="container">
        <div class="video-box mt-0">
            <div class="image">
                <img src="assets/img/video-img2.jpg" class="shadow" alt="image">
            </div>
            <a href="https://www.youtube.com/watch?v=PWvPbGWVRrU" target="_blank" class="video-btn"><i class="flaticon-play"></i></a>
        </div>
    </div>
</div>